import { render, staticRenderFns } from "./page2part8.vue?vue&type=template&id=25434dee&scoped=true"
var script = {}
import style0 from "./page2part8.vue?vue&type=style&index=0&id=25434dee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25434dee",
  null
  
)

export default component.exports